/**
 * @description Can be swapped with the primary warning color.
 */

const yellow = {
  25: "#FEFDF0",
  50: "#FEFBE8",
  100: "#FEF7C3",
  200: "#FEEE95",
  300: "#FDE272",
  400: "#FAC515",
  500: "#EAAA08",
  600: "#CA8504",
  700: "#A15C07",
  800: "#854A0E",
  900: "#713B12",
  950: "#542C0D",
};

export default yellow;
